import { LoadingStageModel, ValueModel } from '@kts-front/models';
import { runInAction } from 'mobx';

import { strapiApiUrls } from 'configs/strapiApiUrl';
import { MediaModel } from 'entities/MediaModel/MediaModel';
import { requestStrapi } from 'utils/requestStrapi';

import { GeneralInformationServer, InfoLink, SocialLink } from './types';

export class GeneralInformationStrapi {
  readonly loadingStage = new LoadingStageModel();
  readonly infoLinks = new ValueModel<Array<InfoLink>>([]);
  readonly socialLinks = new ValueModel<Array<SocialLink>>([]);

  private readonly _request = requestStrapi<GeneralInformationServer, any>();

  async fetch(): Promise<void> {
    this.loadingStage.loading();

    const response = await this._request.request({
      url: strapiApiUrls.generalInformation({
        populate: {
          socialLinks: {
            populate: {
              logo: {
                populate: '*',
              },
            },
          },
          infoLinks: {
            populate: '*',
          },
        },
      }),
    });

    runInAction(() => {
      if (response.isError || !response.data) {
        this.loadingStage.error();

        return;
      }

      this.infoLinks.change(response.data.infoLinks ?? []);
      this.socialLinks.change(
        (response.data.socialLinks ?? []).map((socialLink) => ({
          ...socialLink,
          logo: MediaModel.fromJson(socialLink.logo),
        })),
      );
      this.loadingStage.success();
    });
  }
}
